<div>
  <div class="logo"></div>
  <ng-container *ngFor="let item of navItems">
    <a
      *ngIf="item.routerLink; else externalItem"
      class="nav-item"
      [routerLink]="item.routerLink"
      routerLinkActive="active-link"
    >
      <ng-template *ngTemplateOutlet="navItemContent"></ng-template>
    </a>
    <ng-template #externalItem>
      <a class="nav-item" [href]="item.href" [target]="item.target">
        <ng-template *ngTemplateOutlet="navItemContent"></ng-template>
      </a>
    </ng-template>
    <ng-template #navItemContent>
      <mat-icon
        *ngIf="item.icon"
        class="mb-1"
        fontSet="material-icons-outlined"
      >
        {{ item.icon }}
      </mat-icon>
      <span class="compact-hide">{{ item.label }}</span>
    </ng-template>
  </ng-container>
</div>
<div>
  <div class="compact-hide resources-title overline">Resources</div>
  <a
    class="nav-item"
    href="https://www.facebook.com/groups/688197601802713"
    target="_blank"
  >
    <mat-icon class="mb-1" fontSet="material-icons-outlined">groups</mat-icon>
    <span class="compact-hide">Facebook Group</span>
  </a>
  <button
    type="button"
    class="nav-item help-button"
    (click)="helpMenuTrigger.openMenu()"
  >
    <mat-icon class="mb-1 material-icons-outlined">help_outlined</mat-icon>
    <span class="flex-grow-1 compact-hide">Help & Support</span>
    <mat-icon class="compact-hide">arrow_right</mat-icon>
    <div
      #helpMenuTrigger="matMenuTrigger"
      [matMenuTriggerFor]="helpMenu"
      class="help-menu-trigger"
    ></div>
  </button>
</div>

<mat-menu #helpMenu="matMenu" xPosition="after">
  <div class="help-and-support-menu p-3">
    <a
      *ngIf="isPaid"
      class="help-and-support-menu-item mb-3"
      target="_blank"
      [href]="lms_url"
    >
      <mat-icon class="mb-1">school</mat-icon>
      <div class="pl-3 help-menu-item">
        <div class="help-menu-item-title">Telehealth Institute</div>
        <div class="help-menu-item-description">
          Become an expert with case studies, practice exercises, and
          demonstrations
        </div>
      </div>
    </a>
    <a
      class="help-and-support-menu-item mb-3"
      target="_blank"
      href="https://support.presence.com"
    >
      <mat-icon class="mb-1">help_center</mat-icon>
      <div class="pl-3 help-menu-item">
        <div class="help-menu-item-title">Help Center</div>
        <div class="help-menu-item-description">
          Watch video tutorials and read user guides.
        </div>
      </div>
    </a>
    <a
      class="help-and-support-menu-item mb-3"
      target="_blank"
      (click)="openSupportChat()"
    >
      <mat-icon class="mb-1">support_agent</mat-icon>
      <div class="pl-3 help-menu-item">
        <div class="help-menu-item-title">Support Chat</div>
        <div class="help-menu-item-description">
          Having tech issues? Chat with a real person right now.
        </div>
      </div>
    </a>
    <a
      class="help-and-support-menu-item mb-3"
      target="_blank"
      href="https://setup.presencelearning.com"
    >
      <mat-icon class="mb-1">laptop</mat-icon>
      <div class="pl-3 help-menu-item">
        <div class="help-menu-item-title">Tech Check</div>
        <div class="help-menu-item-description">
          Confirm your computer and equipment are ready to work.
        </div>
      </div>
    </a>
    <hr class="help-menu-divider" />
    <a
      *ngIf="isPaid"
      class="help-and-support-menu-item mb-3"
      target="_blank"
      href="mailto:askaclinician@presence.com"
    >
      <div class="help-menu-item">
        <div class="help-menu-item-title">Clinical Support</div>
        <span class="help-menu-email">askaclinician&#64;presence.com</span>
      </div>
    </a>
    <a
      class="help-and-support-menu-item mb-3"
      target="_blank"
      href="mailto:asksupport@presence.com"
    >
      <div class="help-menu-item">
        <div class="help-menu-item-title">Technical Support</div>
        <span class="help-menu-email">asksupport&#64;presence.com</span>
      </div>
    </a>
    <hr class="help-menu-divider" />
    <div class="help-menu-item">
      <div class="help-menu-item-title">Version: {{ version }}</div>
    </div>
  </div>
</mat-menu>
